<div class="lib-star-control" (mouseleave)="_resetHighlightIndex()">
  @for (dummy of [].constructor(maxRating()); let index = $index; track index) {
    <ion-button
      (click)="_changeRating($event)"
      (mousemove)="_setHighlightIndex($event)"
      [class.active]="_determineIconColor(index) && !readonly()"
      [class.disabled]="readonly()"
      [class.highlight]="_determineHighlightIconColor(index)"
      id="{{ index }}"
      fill="clear"
    >
      <ion-icon slot="icon-only" name="{{ _determineIcon(index) }}" />
    </ion-button>
  }
</div>
